enum DrawerDirections {
  RIGHT = 'right',
  BOTTOM = 'bottom',
  FULLHEIGHT = 'full-height',
  LEFT = 'left',
}

export { DrawerDirections };
